import {
  IN_REPAIR_BADGE_FONT_SIZE,
  IN_REPAIR_EDD_TEXT_STYLES,
  IN_REPAIR_PHASE_OPTIONS,
  IN_REPAIR_RAG_ACTIVE_BORDER,
  IN_REPAIR_RAG_COLORS,
  IN_REPAIR_SC_GROUP_STYLE,
  IN_REPAIR_STATUS_STYLES,
  IN_REPAIR_SUGGESTED_ACTION_STYLE,
} from "./inRepairListingConstants";

export const RO_DETAIL_QUERY_OPEN = "open_ro";
export const RO_DETAIL_QUERY_RO = "ro";
export const RO_DETAIL_QUERY_ID = "id";

/** Dedicated RO detail payload key for the PN lines table. */
export const RO_DETAIL_PART_NUMBERS_KEY = "pn_history";

/** Plain-text tab labels for RO detail back link (matches In-Repair tabs). */
export const RO_DETAIL_PAGE_BACK_LABELS = {
  listing: "In-Repair Listing",
  "priority-view": "Priority View",
  "rve-snapshot": "RVE Snapshot",
  "vendor-scorecard": "Vendor Scorecard",
  analytics: "Analytics",
  "data-quality": "Data Quality",
};

export const RO_DETAIL_DEFAULT_BACK_LABEL = "listing";

export const RO_DETAIL_COLORS = {
  pageBg: "var(--secondary-color)",
  cardBg: "#ffffff",
  sidebarBg: "var(--alabaster-color)",
  statBoxBg: "var(--blackhaze-color)",
  border: "var(--alto-color)",
  borderLight: "var(--alto-color)",
  primaryText: "var(--primary-color)",
  secondaryText: IN_REPAIR_SUGGESTED_ACTION_STYLE.color,
  mutedText: "#8c95a6",
  black: "#000000",
  link: "var(--blue)",
  navy: IN_REPAIR_SC_GROUP_STYLE.color,
  stepperPendingBg: "var(--blackhaze-color)",
  stepperPendingText: "#8c95a6",
  stepperCompletedBg: "#e6f5ea",
  stepperCompletedText: "#1a6e30",
  stepperAwaitingCustomerBg: "#0d9488",
  stepperAwaitingCustomerText: "#ffffff",
  green: IN_REPAIR_STATUS_STYLES["As per plan"].bg,
  greenBg: IN_REPAIR_RAG_COLORS.green.bg,
  greenText: IN_REPAIR_RAG_COLORS.green.text,
  amber: IN_REPAIR_STATUS_STYLES["Nearing Due"].bg,
  amberBg: IN_REPAIR_RAG_COLORS.amber.bg,
  amberText: IN_REPAIR_RAG_COLORS.amber.text,
  red: IN_REPAIR_STATUS_STYLES.Overdue.bg,
  grey: IN_REPAIR_STATUS_STYLES["No EDD"].bg,
  purple: IN_REPAIR_STATUS_STYLES.Stalled.bg,
  redText: IN_REPAIR_EDD_TEXT_STYLES.red.color,
  activeStepperBg: IN_REPAIR_RAG_ACTIVE_BORDER,
  suggestedActionBorder: IN_REPAIR_STATUS_STYLES["Nearing Due"].bg,
};

export const RO_DETAIL_FONT = {
  pageTitle: "var(--font-size-16)",
  body: IN_REPAIR_BADGE_FONT_SIZE,
  caption: "var(--font-size-11)",
  sectionLabel: "var(--font-size-11)",
  sectionLabelExtra: "var(--font-size-11)",
  fieldLabel: "var(--font-size-11)",
  fieldValue: IN_REPAIR_BADGE_FONT_SIZE,
  statValue: "var(--font-size-16)",
  statCaption: "var(--font-size-11)",
  subtitle: "var(--font-size-13)",
  subtitleEmphasis: "var(--font-size-13)",
  backLink: "var(--font-size-11)",
  stepperPhase: "var(--font-size-11)",
  stepperShort: "var(--font-size-11)",
  phaseHistoryTitle: IN_REPAIR_BADGE_FONT_SIZE,
  phaseHistoryNote: "var(--font-size-11)",
  priorityRow: "var(--font-size-11)",
  slaTitle: "var(--font-size-11)",
  slaMeta: "var(--font-size-11)",
  suggestedAction: IN_REPAIR_BADGE_FONT_SIZE,
  suggestedReason: "var(--font-size-11)",
  partNumberNote: "var(--font-size-11)",
  infoNote: "var(--font-size-11)",
};

export const RO_DETAIL_LAYOUT = {
  pagePaddingX: 2,
  pagePaddingTop: 1.5,
  sectionGap: 1.25,
  cardPadding: 1.5,
  cardRadius: "4px",
  cardBorderLeftWidth: "3px",
  statBoxRadius: "4px",
  statBoxPadding: "8px 10px",
  gridGap: "10px",
  fieldGap: "7px",
  sidebarWidth: "310px",
  stepperContentGap: 2,
  slaBarHeight: "7px",
  minHeightEmpty: "400px",
  minHeightNotFound: "320px",
};

export const RO_DETAIL_RAG_PILL_STYLE = {
  Green: { bg: RO_DETAIL_COLORS.green, color: "#ffffff" },
  Amber: { bg: RO_DETAIL_COLORS.amber, color: "#ffffff" },
  Red: { bg: RO_DETAIL_COLORS.red, color: "#ffffff" },
  Gray: { bg: RO_DETAIL_COLORS.grey, color: "#ffffff" },
  Grey: { bg: RO_DETAIL_COLORS.grey, color: "#ffffff" },
  Purple: { bg: RO_DETAIL_COLORS.purple, color: "#ffffff" },
};

export const RO_DETAIL_RAG_SLA_FALLBACK_PCT = {
  Green: 40,
  Amber: 70,
  Red: 100,
  Gray: 15,
  Grey: 15,
  Purple: 10,
};

export const RO_DETAIL_ECON_FLAG_COLORS = {
  high: RO_DETAIL_COLORS.redText,
  review: RO_DETAIL_COLORS.amberText,
  default: RO_DETAIL_COLORS.secondaryText,
  positive: RO_DETAIL_COLORS.greenText,
};

export const RO_DETAIL_PHASE_HISTORY_ICON = {
  completed: { stroke: RO_DETAIL_COLORS.green },
  active: { stroke: RO_DETAIL_COLORS.amber },
  pending: { stroke: RO_DETAIL_COLORS.mutedText },
};

export const RO_DETAIL_DEFAULT_WORKFLOW_STEPPER = IN_REPAIR_PHASE_OPTIONS.map(
  ({ value }) => ({
    phase: value,
    status: "pending",
  })
);

export const RO_DETAIL_EMPTY_MESSAGES = {
  noSelection: "Select a repair order from the In-Repair Listing to view details.",
  notFound: "Repair order details not found.",
};
